import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchUserTiles } from 'store/slices/offlineTilesSlice';
import UploadSection from './UploadSection';
import MapList from './MapList';
import * as S from './styles';

export default function OfflineTiles() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(fetchUserTiles());
	}, [dispatch]);

	return (
		<S.Container>
			<S.Box>
				<S.Header>
					{/* <S.Title>Mapas Offline</S.Title> */}
					<S.Description>
						Faça upload de arquivos .tif, .tiff ou .pdf (geopdf) para usar offline no ACI. Tamanho máximo por arquivo:
						200MB.
					</S.Description>
				</S.Header>

				<UploadSection />
			</S.Box>

			<MapList />
		</S.Container>
	);
}
